<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div style="min-height: 30vh">
        <table>
          <thead>
            <tr>
              <th class="ts-text-xs ts-w-1/3">
                {{ $t('studentScoringComponentEntry.subject') }} :
                {{ subjectName }}
              </th>
              <th class="ts-text-xs ts-text-right ts-w-2/3">
                {{ $t('studentScoringComponentEntry.actualScore') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(mainData, index) in dataInput">
              <tr :key="index">
                <td class="ts-text-sm text-left">
                  <span class="badge badge-primary">
                    <p>{{ mainData.comp_item_name }}</p>
                  </span>
                </td>
              </tr>
              <tr
                v-for="sub in mainData.component_items"
                :key="sub.subject_comp_detail_id"
              >
                <td class="ts-text-right ts-text-xs">
                  {{ sub.subject_comp_item_detail_name }}
                </td>
                <td>
                  <input
                    type="number"
                    v-model.number="sub.actual_score"
                    class="ts-text-right ts-w-full form-control form-control-sm"
                    max="20"
                    :disabled="isInputDisabled(mainData, sub)"
                    :class="{
                      'is-invalid': errors.has(
                        'component_items.' +
                          sub.subject_comp_detail_id +
                          '.actual_score'
                      )
                    }"
                  />
                </td>
                <td
                  class="ts-whitespace-no-wrap"
                  @dblclick="() => (sub.disable = false)"
                >
                  <input
                    type="number"
                    class="text-right inline-block ts-w-16 form-control form-control-sm"
                    disabled
                    :value="sub.max_score"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="row mt-3">
        <div class="col-md-8 d-flex align-items-center">
          <p class="text-danger" v-if="show_alert">
            <i class="fas fa-exclamation-triangle"></i>
            <span class="ts-text-xs">{{
              $t(
                'studentScoringComponentEntry.somethingwrongwithabovecomponentPleasecheckitandtrytoclickbuttonsaveagain'
              )
            }}</span>
          </p>
        </div>
        <div class="col-md-4 text-right">
          <ts-button class="mr-2" @click.prevent="$emit('closeModal')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { isEmpty } from 'lodash'
import httpClient from '@/http-client'

export default {
  name: 'studentScoringComponentEntryNumeric',
  props: ['value'],
  data() {
    return {
      waiting: false,
      loading: false,
      show_alert: false,
      errors: new Errors(),
      scoreComponents: [],
      model: {},
      dataInput: [],
      successCreate: [],
      subjectComponentItemDetails: [],
      actual_score_for_main_component_display: [], // for display max score on main component
      userRoles: []
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
  },
  computed: {
    ...mapState('studentScoringComponentEntry', ['subjects']),
    subjectName() {
      return this.subjects.find(s => s.value == this.model.subject_id).label
    },
    authUser() {
      return this.$store.state.authUser
    },
    hasAttendanceUpdateRole() {
      const checkRole = name => {
        if (!name || typeof name !== 'string') return false
        const normalized = name.trim().toLowerCase()
        return (
          normalized === 'vice president of academic division & iqa office' ||
          normalized === 'vice president of academic division and iqa office' ||
          normalized.includes('vice president of academic division') ||
          normalized.includes('iqa office') ||
          normalized === 'update score attendance' ||
          normalized === 'update score attendance role' ||
          normalized.includes('update score attendance') ||
          normalized === 'score attendance'
        )
      }

      if (Array.isArray(this.userRoles) && this.userRoles.length > 0) {
        if (
          this.userRoles.some(r => {
            if (typeof r === 'string') return checkRole(r)
            if (r && typeof r === 'object' && r.name) return checkRole(r.name)
            return false
          })
        ) {
          return true
        }
      }

      const authUser = this.authUser
      if (!authUser) return false

      if (Array.isArray(authUser.roles)) {
        if (
          authUser.roles.some(r => {
            if (typeof r === 'string') return checkRole(r)
            if (r && typeof r === 'object' && r.name) return checkRole(r.name)
            return false
          })
        ) {
          return true
        }
      }

      if (Array.isArray(authUser.permissions)) {
        if (
          authUser.permissions.some(p => {
            if (typeof p === 'string') {
              const pNorm = p.trim().toLowerCase()
              return (
                pNorm === 'update score attendance' ||
                pNorm === 'update-score-attendance'
              )
            }
            return false
          })
        ) {
          return true
        }
      }

      return false
    },
    hasAcademicLeadershipRole() {
      const checkRole = name => {
        if (!name || typeof name !== 'string') return false
        const normalized = name.trim().toLowerCase()
        return (
          normalized === 'vice president of academic division & iqa office' ||
          normalized === 'vice president of academic division and iqa office' ||
          normalized.includes('vice president of academic division') ||
          normalized.includes('iqa office')
        )
      }

      if (Array.isArray(this.userRoles) && this.userRoles.length > 0) {
        if (
          this.userRoles.some(r => {
            if (typeof r === 'string') return checkRole(r)
            if (r && typeof r === 'object' && r.name) return checkRole(r.name)
            return false
          })
        ) {
          return true
        }
      }

      const authUser = this.authUser
      if (!authUser) return false

      if (Array.isArray(authUser.roles)) {
        if (
          authUser.roles.some(r => {
            if (typeof r === 'string') return checkRole(r)
            if (r && typeof r === 'object' && r.name) return checkRole(r.name)
            return false
          })
        ) {
          return true
        }
      }

      return false
    },
    hasSpecificAttendanceOnlyRole() {
      const checkRole = name => {
        if (!name || typeof name !== 'string') return false
        const normalized = name.trim().toLowerCase()
        return (
          normalized === 'update score attendance' ||
          normalized === 'update score attendance role' ||
          normalized === 'score attendance'
        )
      }

      if (
        Array.isArray(this.userRoles) &&
        this.userRoles.some(r =>
          checkRole(typeof r === 'string' ? r : r && r.name)
        )
      ) {
        return true
      }

      const authUser = this.authUser
      if (
        authUser &&
        Array.isArray(authUser.roles) &&
        authUser.roles.some(r =>
          checkRole(typeof r === 'string' ? r : r && r.name)
        )
      ) {
        return true
      }

      return false
    },
    isAdmin() {
      const checkAdmin = r => {
        const name = typeof r === 'string' ? r : r && r.name ? r.name : ''
        const norm = name.trim().toLowerCase()
        return (
          norm === 'admin' ||
          norm === 'administrator' ||
          norm === 'super admin' ||
          norm === 'super-admin' ||
          norm === '*'
        )
      }

      if (Array.isArray(this.userRoles) && this.userRoles.some(checkAdmin)) {
        return true
      }

      const authUser = this.authUser
      if (!authUser) return false

      if (Array.isArray(authUser.roles)) {
        if (authUser.roles.some(checkAdmin)) {
          return true
        }
      }

      if (Array.isArray(authUser.permissions)) {
        if (authUser.permissions.includes('delete-roles')) {
          return true
        }
      }

      return false
    },
    canUpdateScoreAttendance() {
      if (this.isTeacher) return false
      if (this.isAdmin) return true
      if (this.hasAcademicLeadershipRole) return true
      if (this.hasAttendanceUpdateRole) return true
      return false
    },
    isRestrictedToAttendanceOnly() {
      if (this.isTeacher) return false
      if (this.isAdmin || this.hasAcademicLeadershipRole) return false
      return this.hasSpecificAttendanceOnlyRole
    },
    isTeacher() {
      const userType = this.authUser && this.authUser.user_type
      return (
        typeof userType === 'string' && userType.toLowerCase() === 'teacher-api'
      )
    }
  },
  methods: {
    ...mapActions('studentScoringComponentEntry', [
      'store',
      'getSubjectComponentItems',
      'getSubjectComponentItemDetails'
    ]),
    async ensureUserRoles() {
      if (this.isTeacher) {
        this.userRoles = []
        return
      }
      if (Array.isArray(this.userRoles) && this.userRoles.length > 0) return
      try {
        let roles = []
        const res = await httpClient.get('/api/home/staff-profiles')
        if (
          res &&
          res.data &&
          res.data.data &&
          Array.isArray(res.data.data.roles)
        ) {
          roles = res.data.data.roles
        } else if (res && res.data && Array.isArray(res.data.roles)) {
          roles = res.data.roles
        }

        if (!roles.length && this.authUser && this.authUser.user_id) {
          const userRes = await httpClient.get(
            `/api/users/${this.authUser.user_id}`
          )
          if (
            userRes &&
            userRes.data &&
            userRes.data.data &&
            Array.isArray(userRes.data.data.roles)
          ) {
            roles = userRes.data.data.roles
          } else if (
            userRes &&
            userRes.data &&
            Array.isArray(userRes.data.roles)
          ) {
            roles = userRes.data.roles
          }
        }
        this.userRoles = roles
      } catch (e) {
        // Fallback gracefully without throwing
      }
    },
    isAttendance(mainData, sub = null) {
      if (mainData) {
        if (
          mainData.is_auto_from_att === true ||
          mainData.is_auto_from_att === 1 ||
          mainData.is_auto_from_att === '1'
        ) {
          return true
        }
        const compName = (mainData.comp_item_name || '').toLowerCase()
        if (
          compName.includes('attendance') ||
          compName.includes('វត្តមាន') ||
          /\batt\b/i.test(compName)
        ) {
          return true
        }
      }
      if (sub && sub.subject_comp_item_detail_name) {
        const subName = sub.subject_comp_item_detail_name.toLowerCase()
        if (
          subName.includes('attendance') ||
          subName.includes('វត្តមាន') ||
          /\batt\b/i.test(subName)
        ) {
          return true
        }
      }
      return false
    },
    isInputDisabled(mainData, sub) {
      const isAtt = this.isAttendance(mainData, sub)
      if (isAtt) {
        return !this.canUpdateScoreAttendance
      }
      if (this.isRestrictedToAttendanceOnly) {
        return true
      }
      return false
    },
    async fetchData() {
      this.loading = true
      await this.ensureUserRoles()
      await this.getSubjectComponentItems({
        // get component base on subject
        subject_id: this.model.subject_id
      })
        .then(response => {
          this.createInputData(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      // find subject component item details
      await this.getSubjectComponentItemDetails(this.model)
        .then(response => {
          this.subjectComponentItemDetails = []
          if (!isEmpty(response.data) || response.data.length > 0) {
            this.subjectComponentItemDetails = response.data
            this.inputEditData()
          }
        })
        .catch(error => {
          console.log(error.message)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    inputEditData() {
      this.dataInput.forEach(e => {
        e.component_items.forEach(ec => {
          if (
            this.subjectComponentItemDetails.find(
              el => el.subject_comp_detail_id == ec.subject_comp_detail_id
            )
          ) {
            ec.actual_score = this.subjectComponentItemDetails.find(
              el => el.subject_comp_detail_id == ec.subject_comp_detail_id
            ).actual_score

            ec.scoring_id = this.subjectComponentItemDetails.find(
              el => el.subject_comp_detail_id == ec.subject_comp_detail_id
            ).scoring_id
          }
        })
      })
    },
    createInputData(data) {
      // Create Input Data
      data.forEach(e => {
        this.dataInput.push({
          student_id: this.model.student_id,
          st_class_id: this.model.st_class_id,
          scoring_cycle_id: this.model.scoring_cycle_id,
          cycle_value: this.model.cycle_value,
          subject_comp_id: e.subject_comp_id,
          subject_id: e.subject_id,
          comp_item_name: e.comp_item_name,
          is_auto_from_att: e.is_auto_from_att,
          component_items: e['component_items'].map(el => ({
            scoring_id: el.scoring_id ? el.scoring_id : 0,
            subject_comp_detail_id: el.subject_comp_detail_id,
            subject_comp_item_detail_name: el.subject_comp_item_detail_name,
            actual_score: -1,
            max_score: el.max_score
          }))
        })
      })
    },
    async onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.successCreate = []
      this.show_alert = false

      let itemsToSave = this.dataInput
      if (this.isRestrictedToAttendanceOnly) {
        itemsToSave = this.dataInput.filter(item => this.isAttendance(item))
      } else if (!this.canUpdateScoreAttendance) {
        itemsToSave = this.dataInput.filter(item => !this.isAttendance(item))
      }

      if (itemsToSave.length === 0) {
        this.waiting = false
        this.$toasted.info(
          this.isRestrictedToAttendanceOnly
            ? 'No attendance score component found to update.'
            : 'No score components available to update.'
        )
        return
      }

      for (const item of itemsToSave) {
        await this.store(item)
          .then(() => {
            this.successCreate.push(item)
          })
          .catch(error => {
            this.show_alert = true
            this.waiting = false
            this.$toasted.error(error.message)
            if (error.errors != undefined) {
              this.errors = new Errors(error.errors)
            }
          })
        if (this.show_alert) {
          break
        }
      }
      this.successCreate.forEach(el => {
        const index = this.dataInput.indexOf(el)
        if (index !== -1) {
          this.dataInput.splice(index, 1)
        }
      })
      this.waiting = false
      if (
        !this.show_alert &&
        (this.isRestrictedToAttendanceOnly ||
          !this.canUpdateScoreAttendance ||
          this.dataInput.length === 0)
      ) {
        this.$emit('closeModal')
      }
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
</style>
